// src/helpers/propiedad.js

export const toInt = (v) => Number(v ?? 0);

export function makeCodigo({ manzana, lote }) {
  return `MZ${toInt(manzana)}-LT${toInt(lote)}`;
}

export function makeAlias({ fraccNombre, fraccionamientoId, manzana, lote, tipo }) {
  const fracc = (fraccNombre || fraccionamientoId || "").toString().trim();
  const mz = manzana ? `Mz ${manzana}` : "";
  const lt = lote ? `Lt ${lote}` : "";
  const core = [fracc, mz, lt].filter(Boolean).join(" ").trim();
  return core || (tipo || "Terreno");
}

/**
 * Construye el documento de Propiedad unificando formatos y tokens de búsqueda.
 * Úsalo al crear/editar:  {...buildPropDoc(data)}  (luego añade tus campos específicos)
 */
export function buildPropDoc(base) {
  const tipo = base.tipo || "Terreno";
  const codigoHumano = makeCodigo(base);
  const alias = makeAlias({ ...base, tipo });
  const nombre = (base.nombre || "").trim() || alias;

  const tokens = [
    (base.folio || "").toUpperCase(),
    codigoHumano.toUpperCase(),
    alias.toUpperCase(),
    `${toInt(base.manzana)}-${toInt(base.lote)}`,
    tipo.toUpperCase(),
    (base.ubicacion || "").toUpperCase(),
  ].filter(Boolean);

  return {
    // identidad
    folio: base.folio || "",
    tipo,
    fraccionamientoId: base.fraccionamientoId || "",
    fraccNombre: base.fraccNombre || "",
    manzana: base.manzana ? String(base.manzana) : "",
    manzanaInt: toInt(base.manzana),
    lote: base.lote ? String(base.lote) : "",
    loteInt: toInt(base.lote),

    // nombres y códigos
    codigoHumano,
    alias,
    nombre,

    // precios y ubicación (normalizados, si venían)
    metros2: Number(base.metros2 || 0),
    precioContado: Number(base.precioContado || 0),
    precioFinanciado: Number(base.precioFinanciado || 0),
    ubicacion: base.ubicacion || "",

    // estado por defecto
    estado: base.estado || "disponible",
    disponible: base.disponible ?? true,
    activo: base.activo ?? true,

    // buscador
    buscadorTokens: tokens,
  };
}
